import CreateDrive from "../../../../football/rules/general/drives/create-drive";

export default class FlagCreateDrive extends CreateDrive {
    kickoffContextChanges() {}
}
